import React from 'react';
import {
    StyledLeftPanel, StyledTabsPanel, StyledDetailsPanel, StyledWrapper
} from './styles';

type INftPageLayout = React.FC & {
    LeftPanel: typeof LeftPanel;
    DetailsPanel: typeof DetailsPanel;
    TabsPanel: typeof TabsPanel;
}

export const NftPageLayout: INftPageLayout = ({ children }) => (
    <StyledWrapper>
        {children}
    </StyledWrapper>
);

const LeftPanel: React.FC = ({ children }) => (
    <StyledLeftPanel>
        {children}
    </StyledLeftPanel>
);

const DetailsPanel: React.FC = ({ children }) => (
    <StyledDetailsPanel>
        {children}
    </StyledDetailsPanel>
);

const TabsPanel: React.FC = ({ children }) => (
    <StyledTabsPanel>
        {children}
    </StyledTabsPanel>
);

NftPageLayout.LeftPanel = LeftPanel;
NftPageLayout.DetailsPanel = DetailsPanel;
NftPageLayout.TabsPanel = TabsPanel;
